import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { ChevronsUpDown } from 'lucide-react';

export function QboTargetPicker({ candidates, onPick, disabled, selectedName, testKey }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline" size="sm" role="combobox" aria-expanded={open} disabled={disabled}
          className={`w-full md:w-[220px] justify-between font-normal ${selectedName ? 'text-slate-800' : 'text-slate-500'}`}
          data-testid={`${testKey}-picker-trigger`}
        >
          <span className="truncate">{selectedName || 'Search QBO targets…'}</span>
          <ChevronsUpDown className="ml-2 h-3.5 w-3.5 shrink-0 opacity-50 flex-shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[300px] p-0" align="start" data-testid={`${testKey}-picker-popover`}>
        <Command>
          <CommandInput placeholder="Type to filter…" data-testid={`${testKey}-picker-search`} />
          <CommandList>
            <CommandEmpty data-testid={`${testKey}-picker-empty`}>No match found.</CommandEmpty>
            <CommandGroup>
              {candidates.map((c) => (
                <CommandItem
                  key={c.id}
                  value={c.name}
                  onSelect={() => { setOpen(false); onPick(c.id, c.name); }}
                  data-testid={`${testKey}-picker-option-${c.id}`}
                >
                  {c.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
